import axios from "axios";
import apiUrls from "src/api";
import type { ReleaseFeedEntry } from "src/model/model";

// Axios functions for the creator-facing "What's new" feed (Phase 4 endpoints).
// JWT is attached globally (common/util/auth.ts) and the response interceptor
// passes these plain payloads through — so we just return response.data.

export interface FetchReleaseFeedParams {
  limit?: number;
  offset?: number;
  surface?: "web" | "vr" | "both";
}

export async function fetchReleaseFeed(
  params: FetchReleaseFeedParams = {},
): Promise<ReleaseFeedEntry[]> {
  const response = await axios.get(apiUrls.releases.feed, { params });
  return response.data;
}

export async function getUnreadCount(): Promise<{ count: number }> {
  const response = await axios.get(apiUrls.releases.unreadCount);
  return response.data;
}

export async function markSeen(): Promise<{ lastSeenReleaseId: number }> {
  const response = await axios.post(apiUrls.releases.markSeen);
  return response.data;
}
